var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigation2 = function SvgNavigation2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.081a.6.6 0 0 1 .563.393l6.85 18.59a.601.601 0 0 1-.86.73L12 18.048 5.45 21.793a.601.601 0 0 1-.862-.728l6.85-18.59A.6.6 0 0 1 12 2.08M6.284 19.933l5.419-3.096a.6.6 0 0 1 .595 0l5.418 3.096L12 4.415z"
  })));
};
export default SvgNavigation2;